import { render, staticRenderFns } from "./TallerExpress.vue?vue&type=template&id=76a5a2ae&scoped=true"
import script from "./TallerExpress.vue?vue&type=script&lang=js"
export * from "./TallerExpress.vue?vue&type=script&lang=js"
import style0 from "./TallerExpress.vue?vue&type=style&index=0&id=76a5a2ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a5a2ae",
  null
  
)

export default component.exports